import { Outlet, useNavigate, useLocation } from "react-router-dom";
import AdminSidebar from "../AdminSidebar/AdminSidebar";
import "./AdminLayout.css";

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminData");
    localStorage.removeItem("isAdmin");
    navigate("/adminLogin");
  };

  return (
    <div className="admin-layout">
      {/* Use AdminSidebar Component (includes mobile toggle) */}
      <AdminSidebar />
      
      {/* Main Content Area */}
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}